export default __webpack_public_path__ + "static/media/arrowup.7ece2254.svg";